export enum ExistsDropdownList {
  ALL = 'ALL',
  EXISTS = 'EXISTS',
  DOES_NOT_EXIST = 'DOES NOT EXIST',
}
